import React, { useEffect, useState } from 'react';
import { InnovationGraph } from './index';
import { NonIdealState } from '@blueprintjs/core';

/**
 * ChartWrapper for the physics based clustering diagram.
 *
 * Expects: [{count, labels:['term'...]}]
 * Converts: [nodes: [], links: [{source, target}]]
 *
 * @param widgetConfiguration
 * @param dimensions
 * @param data
 * @returns {*}
 * @constructor
 */
export function InnovationGraphWrapper({widgetConfiguration, loading, dimensions, data}) {
  const [convertedData, setConvertedData] = useState({nodes: [], links: []});

  useEffect(() => {
    const nodes = [];
    const links = [];

    // empty data is "valid" and different than null.
    if (data?.values?.length === 0) {
      setConvertedData({nodes: [], links: []});
    }

    // the data is null, or in the wrong shape...so we exit
    if (!data || !data?.values)
      return;

    // for each cluster, create a parent node
    data.values.forEach(({size, value, values, weight}, i) => {
      const parent = {label: value, type: "category", colorIndex: i, id: i, maxParents: data.values.length, count: size, weight };
      nodes.push(parent);

      // create a child node for each term in the cluster and link to parent
      values.forEach(({size, value, values, weight}) => {
        const child = {label: value, type: "proposal", count: 1, colorIndex: i, maxParents: data.values.length, parentId: i};
        nodes.push(child);
        links.push({source: parent, target: child});
      });
    });

    setConvertedData({nodes, links});
  }, [data]);

  return (
    (convertedData?.nodes?.length > 0)
      ? <InnovationGraph data={convertedData} dimensions={dimensions}/>
      : <NonIdealState title={"No Clusters Found"}
                       icon={'graph-remove'}
                       description={'No clusters were found with the given parameters.  Try making another selection'}
      />
  );
}
